module.exports = __webpack_public_path__ + "img/link-min.9822e88c.png";